import React, { useState, useEffect } from 'react';

export function IGWidget() {

    return (
        <div id="igContainer" className="d-flex flex-column justify-content-center border rounded p-3">
            <iframe src='https://widgets.sociablekit.com/instagram-feed/iframe/129441' frameborder='0' width='100%' height='1000'></iframe>
        </div>    );
};